import Vue from 'vue';
import messages, { SUPPORTED, getDefaultLanguage } from '@/locales';

export const i18nState = Vue.observable({
  lang: getDefaultLanguage()
});

function resolve(obj, path) {
  if (!obj || !path) return null;
  return path.split('.').reduce((acc, key) => {
    if (acc == null) return null;
    return acc[key];
  }, obj);
}

/**
 * Translate a dotted key. Falls back to English, then the key itself.
 * @param {string} key
 * @param {Record<string, string|number>} [params]
 * @returns {string}
 */
export function t(key, params) {
  const lang = i18nState.lang;
  let text = resolve(messages[lang], key);
  if (text == null) text = resolve(messages.en, key);
  if (text == null) return key;
  if (typeof text !== 'string') return String(text);
  if (params) {
    Object.keys(params).forEach(k => {
      text = text.replace(new RegExp('\\{' + k + '\\}', 'g'), String(params[k]));
    });
  }
  return text;
}

export function getLanguage() {
  return i18nState.lang;
}

export function setLanguage(lang) {
  if (!SUPPORTED.includes(lang)) return;
  i18nState.lang = lang;
  try {
    localStorage.setItem('language', lang);
  } catch (e) {
    // ignore
  }
  try {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', lang === 'zh' ? 'zh-CN' : lang);
    }
  } catch (e) {
    // ignore
  }
}

export default {
  install(VueCtor) {
    VueCtor.prototype.$t = function (key, params) {
      // Depend on reactive lang so templates re-render on change
      void i18nState.lang;
      return t(key, params);
    };
    Object.defineProperty(VueCtor.prototype, '$lang', {
      get() {
        return i18nState.lang;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n.js